export default __webpack_public_path__ + "maps-examples-user-location-annotation-thumbnail-480-1bdbc6bb3fdc5ac2b5125d55db4bc646.webp";